const elements = require("./elements");

const blossomTreesArr = [
  elements.BLOSSOMS_1.id,
  elements.BLOSSOMS_2.id,
  elements.BLOSSOMS_3.id,
  elements.BLOSSOMS_4.id,
];

const blossomTreesArrReverse = [...blossomTreesArr].reverse();

const motifsArr = [
  elements.KOALA.id,
  elements.STANDING_KANGAROO.id,
  elements.SANTA_SLEIGH.id,
  elements.SANTA_REINDEER.id,
  elements.RIBBON_BELLS.id,
  elements.SNOWMAN.id,
  elements.BELLS.id,
  elements.REINDEER_JANE_MULTI.id,
  elements.REINDEER_BUCKY_CW.id,
  elements.REINDEER_JO_WW.id,
  elements.TRAIN.id,
  elements.MERRY_CHRISTMAS_SIGN.id,
  elements.SANTA.id,
  elements.STOCKINGS.id,
  elements.PENGUINS.id,
  elements.KANGAROO_LOW.id,
  elements.KANGAROO_HIGH.id,
];

const motifsArrReverse = [...motifsArr].reverse();

const snowflakesArr = [
  'NEON_SNOWFLAKE_2',
  'NEON_SNOWFLAKE_1',
  'SNOWFLAKE_ICE_2',
  'SIMPLE_SNOWFLAKES',
  'SNOWFLAKE_ICE_1',
];

const snowflakesArrReverse = [...snowflakesArr].reverse();

const houseArr = [
  elements.ROOF_OUTLINE_MULTI.id,
  elements.GUTTER_LINE_MULTI.id,
  [
    elements.RIBBON_BELLS.id,
    elements.BELLS.id,
    elements.SANTA.id,
    elements.MERRY_CHRISTMAS_SIGN.id,
    elements.TRAIN.id,
  ],
  [
    elements.KOALA.id,
    elements.ELF_TREE_2.id,
    elements.STANDING_KANGAROO.id,
    elements.SNOWMAN.id,
    elements.KANGAROO_LOW.id,
  ],
  [
    elements.FENCE_MULTI.id,
    elements.SANTA_REINDEER.id,
    elements.REINDEER_SLEIGH.id,
    elements.STOCKINGS.id,
    elements.KANGAROO_HIGH.id,
  ],
  [
    elements.REINDEER_BUCKY_MULTI.id,
    elements.REINDEER_JANE_MULTI.id,
    elements.REINDEER_JO_MULTI.id,
    elements.MEGA_TREE_MULTI.id,
    elements.MEGA_TREE_STAR_MULTI.id,
    elements.PENGUINS.id,
  ],

  elements.ROOF_OUTLINE_COOL.id,
  elements.GUTTER_LINE_COOL.id,
  [
    elements.RIBBON_BELLS.id,
    elements.BELLS.id,
    elements.SANTA.id,
    elements.MERRY_CHRISTMAS_SIGN.id,
    elements.TRAIN.id,
  ],
  [
    elements.KOALA.id,
    elements.ELF_TREE_2.id,
    elements.STANDING_KANGAROO.id,
    elements.SNOWMAN.id,
    elements.KANGAROO_LOW.id,
  ],
  [
    elements.FENCE_COOL_WHITE.id,
    elements.SANTA_REINDEER.id,
    elements.REINDEER_SLEIGH.id,
    elements.STOCKINGS.id,
    elements.KANGAROO_HIGH.id,
  ],
  [
    elements.REINDEER_BUCKY_CW.id,
    elements.REINDEER_JANE_CW.id,
    elements.REINDEER_JO_CW.id,
    elements.MEGA_TREE_COOL_WHITE.id,
    elements.MEGA_TREE_STAR_COOL.id,
    elements.PENGUINS.id,
  ],

  elements.ROOF_OUTLINE_WARM.id,
  elements.GUTTER_LINE_WARM.id,
  [
    elements.RIBBON_BELLS.id,
    elements.BELLS.id,
    elements.SANTA.id,
    elements.MERRY_CHRISTMAS_SIGN.id,
    elements.TRAIN.id,
  ],
  [
    elements.KOALA.id,
    elements.ELF_TREE_2.id,
    elements.STANDING_KANGAROO.id,
    elements.SNOWMAN.id,
    elements.KANGAROO_LOW.id,
  ],
  [
    elements.FENCE_WARM_WHITE.id,
    elements.SANTA_REINDEER.id,
    elements.REINDEER_SLEIGH.id,
    elements.STOCKINGS.id,
    elements.KANGAROO_HIGH.id,
  ],
  [
    elements.REINDEER_BUCKY_WW.id,
    elements.REINDEER_JANE_WW.id,
    elements.REINDEER_JO_WW.id,
    elements.MEGA_TREE_WARM_WHITE.id,
    elements.MEGA_TREE_STAR_WARM.id,
    elements.PENGUINS.id,
  ],
];

const houseArrReverse = [...houseArr].reverse();

module.exports = [
  {
    name: "Bounce Blossom Trees BWD",
    animationId: "bounce",
    elements: blossomTreesArr.join(","),
  },
  {
    name: "Bounce Blossom Trees FWD",
    animationId: "bounce",
    elements: blossomTreesArrReverse.join(","),
  },
  {
    name: "Bounce Motifs Right",
    animationId: "bounce",
    elements: motifsArr.join(","),
  },
  {
    name: "Bounce Motifs Left",
    animationId: "bounce",
    elements: motifsArrReverse.join(","),
  },
  {
    name: "Double Sweep Blossom Trees BWD",
    animationId: "sweepdouble",
    elements: blossomTreesArr.join(","),
  },
  {
    name: "Double Sweep Blossom Trees FWD",
    animationId: "sweepdouble",
    elements: blossomTreesArrReverse.join(","),
  },
  {
    name: "Explode Blossom Trees",
    animationId: "explode",
    elements: blossomTreesArrReverse.join(","),
  },
  {
    name: "Explode Motifs",
    animationId: "explode",
    elements: motifsArr.join(","),
  },
  {
    name: "Fill Blossom Trees",
    animationId: "fill",
    elements: blossomTreesArr.join(","),
  },
  {
    name: "Fill Motifs",
    animationId: "fill",
    elements: motifsArr.join(","),
  },
  {
    name: "House Sweep Down",
    animationId: "sweep",
    elements: houseArr.join(","),
  },

  {
    name: "House Sweep Up",
    animationId: "sweep",
    elements: houseArrReverse.join(","),
  },
  {
    name: "Implode Blossom Trees",
    animationId: "implode",
    elements: blossomTreesArr.join(","),
  },
  {
    name: "Implode Motifs",
    animationId: "implode",
    elements: motifsArr.join(","),
  },
  {
    name: "Sweep Blossom Trees BWD",
    animationId: "sweep",
    elements: blossomTreesArr.join(","),
  },
  {
    name: "Sweep Blossom Trees FWD",
    animationId: "sweep",
    elements: blossomTreesArrReverse.join(","),
  },
  {
    name: "Sweep Motifs Right",
    animationId: "sweep",
    elements: motifsArr.join(","),
  },
  {
    name: "Sweep Motifs Left",
    animationId: "sweep",
    elements: motifsArrReverse.join(","),
  },
  {
    name: "Make it snow",
    animationId: "sweep",
    elements: snowflakesArr.join(","),
  },
];
